/**
 * Mit der Offcanvas-Sidebar können Inhalte über einen individuellen Ausgabebereich außerhalb des Viewports ausgegeben
 * werden und über ein Trigger/Toggle von links oder rechts eingefahren werden.
 *
 * @param {string} offcanvasSelector - jQuery Selector der Offcanvas-Sidebar.
 * @param {string} offcanvasToggle - Toggle zum öffnen der Offcanvas-Sidebar.
 * @param {string} offcanvasCloseButton - Toggle zum schließen der Offcanvas-Sidebar.
 **/

function nc_initOffcanvasSidebar(offcanvasSelector, offcanvasToggle, offcanvasCloseButton) {
  var moduleLogger = LoggerManager.get('Offcanvas-Sidebar').setPrefix('Selektor: ' + offcanvasSelector, 'Offcanvas-Toggle: ' + offcanvasToggle, 'Offcanvas-CloseButton: ' + offcanvasCloseButton);
  moduleLogger.trace('INIT START');
  $(document).ready(function () {
    // Aufruf vom Offcanvas Script
    nc_initOffcanvas(offcanvasSelector, offcanvasToggle, offcanvasCloseButton);
  });

  moduleLogger.info('INIT ENDE');
}

function nc_initOffcanvas(offcanvasSelector, offcanvasToggle, offcanvasCloseButton) {
  var moduleLogger = LoggerManager.get('Offcanvas-Sidebar').setPrefix('Selektor: ' + offcanvasSelector, 'Offcanvas-Toggle: ' + offcanvasToggle, 'Offcanvas-CloseButton: ' + offcanvasCloseButton);
  moduleLogger.trace('SCRIPT START');

  // Klick vom Toggle
  $(offcanvasToggle).on('click', function (e) {
    // Füge eine Klasse an den Selector, den Toggle und das HTML
    $(offcanvasSelector).addClass('is-active');
    $(offcanvasToggle).addClass('is-active');
    $('html').addClass('offcanvas-active');
    e.stopPropagation();
  });

  // Klicke an einer beliebigen Stelle im Dokument
  $(document).on('click', function (e) {
    // Wenn ein Element außerhalb des Selektors geklickt wird
    if (!$(e.target).closest(offcanvasSelector).length) {
      // Entferne die zuvor gesetzten Klassen
      $(offcanvasSelector).removeClass('is-active');
      $(offcanvasToggle).removeClass('is-active');
      $('html').removeClass('offcanvas-active');
    }
  });

  // Klick auf den schließen Button
  $(offcanvasCloseButton).on('click', function () {
    // Entferne die zuvor gesetzten Klassen
    $(offcanvasSelector).removeClass('is-active');
    $(offcanvasToggle).removeClass('is-active');
    $('html').removeClass('offcanvas-active');
  });

  // Füge individuelle Klassen an den Selektor und das HTML
  $('html').addClass('offcanvas');

  $(window).on('load', function() {
    $(offcanvasSelector).addClass('offcanvas-visible');
  });

  moduleLogger.info('SCRIPT ENDE');
}